import React from 'react';

export default class DesignComponent extends React.Component {
    constructor(props) {
        super(props);

        this.scroll = this.scroll.bind(this);

        this.refSectionList = React.createRef();
    }

    componentDidMount() {
    }

    scroll($element = this.refSectionList) {
        if ($element && $element.current) {
            const adminBar = document.getElementById('wpadminbar');
            const header = document.querySelector('.site-header');
            const hero = document.querySelector('.main-hero');

            let top = 0;

            if (header && header.offsetHeight) {
                top += header.offsetHeight;
            }

            if (adminBar && adminBar.offsetHeight) {
                top += adminBar.offsetHeight;
            }

            if (hero && hero.offsetHeight) {
                top += hero.offsetHeight;
            }

            // console.log(window.scrollTo);
            // if (scrollTo) {
            //     scrollTo({$target: $element.current, $excludeOffset: top});
            // }
        }
    }

    render() {
        return <div ref={this.refSectionList}>
            {this.props.children}
        </div>
    }
}